import PreviewSection from '../../PreviewSection'

export default function BillingSummaryHTMLPreviewHeaderSection() {}

BillingSummaryHTMLPreviewHeaderSection.prototype = new PreviewSection();

BillingSummaryHTMLPreviewHeaderSection.prototype.init = function( groupingLevelsArray, columnsStrategy ) {
    PreviewSection.prototype.init.call( this );
    this.groupingLevelsArray = groupingLevelsArray;
    this.columnsStrategy = columnsStrategy;

    return this;
};

BillingSummaryHTMLPreviewHeaderSection.prototype.addRows = function( tBody )
{
    var levelsNumber = this.columnsStrategy.getLevelsNumber();
    
    var row1 = this.createRow("headerRow firstHeaderRow");
    this.addCell( row1, ReportPreviewUtils.makeGroupingHeader(this.groupingLevelsArray), "groupingLevelsTitle", 1, levelsNumber);
    this.columnsStrategy.addFirstHeaderRowCells(row1, levelsNumber);
    this.addRow( tBody, row1 );
    
    if ( levelsNumber > 1 ) {
        var row2 = this.createRow("headerRow secondHeaderRow");
        this.columnsStrategy.addSecondHeaderRowCells(row2, levelsNumber);
        this.addRow( tBody, row2 );    
    } 
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/BillingSummaryHTMLPreviewHeaderSection.js